import camelCase from 'lodash/camelCase';

const camelCaseKeys = obj =>
  Object.keys(obj).reduce((acc, key) => {
    acc[camelCase(key)] = obj[key];

    return acc;
  }, {});

export default camelCaseKeys;



// WEBPACK FOOTER //
// ./src/utils/camelCaseKeys.js